import { css } from '../../styles/theme';
import { rem } from 'polished';
import { IButtonStyles } from '../Button/ButtonStyled';

export const StylesAC = css<IButtonStyles>`
    padding: ${rem(10)} ${rem(15)};

    &:hover {
        transition: all 0.3s ease;
    }

    ${({ primary }) =>
        primary &&
        css`
            color: ${({ theme }) => theme.colors.white};
            border: ${rem(1)} solid ${({ theme }) => theme.colors.blue2};
            border-radius: ${rem(24)};
            background: ${({ theme }) => theme.colors.blue2};
            text-transform: capitalize;
            font-size: ${({ theme }) => theme.fontSizes.h4};
            font-family: ${({ theme }) => theme.fonts.fontBase};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            &:hover {
                background: ${({ theme }) => theme.colors.grey5};
                color: ${({ theme }) => theme.colors.white};
                border: 1px solid ${({ theme }) => theme.colors.black};
            }
        `}

    ${({ secondary }) =>
        secondary &&
        css`
            color: ${({ theme }) => theme.colors.white};
            border: ${rem(4)} solid ${({ theme }) => theme.colors.blue1};
            background: ${({ theme }) => theme.colors.blue1};

            &:hover {
                background: ${({ theme }) => theme.colors.secondaryHover};
                color: ${({ theme }) => theme.colors.blue1};
            }
        `}
    
    ${({ primary, disabled }) =>
        primary &&
        disabled &&
        css`
            border-color: ${({ theme }) => theme.colors.primaryDisabled};
        `}
    
    ${({ secondary, disabled }) =>
        secondary &&
        disabled &&
        css`
            background: ${({ theme }) => theme.colors.secondaryDisabled};
            border-color: ${({ theme }) => theme.colors.secondaryDisabled};
            color: ${({ theme }) => theme.colors.white};
        `}
`;
